/* eslint-disable */
import girl1 from "../assets/svg/testimonials/girl1.svg";
import girl2 from "../assets/svg/testimonials/girl2.svg";
import girl3 from "../assets/svg/testimonials/girl3.svg";
import boy1 from "../assets/svg/testimonials/boy1.svg";
import boy2 from "../assets/svg/testimonials/boy2.svg";
import boy3 from "../assets/svg/testimonials/boy3.svg";
export const testimonialsData = [
  {
    id: 1,
    name: "",
    title: "Przedstawiciel handlowy",
    text: "Świetna specjalistka, a do tego super człowiek.",
    image: boy2,
  },
  {
    id: 2,
    name: "",
    title: "Programistka",
    text: "Wizyta u Dominiki to zaczyna być mój obowiązkowy punkt wyjazdu do Warszawy. Wiem, że z czym nie przyjdę, to na pewno mi pomoże i doradzi.",
    image: girl2,
  },
  {
    id: 3,
    name: "",
    title: "Prawniczka",
    text: "Do Pani Dominiki zgłosiłam się w celu przygotowania do porodu i niewielkimi dolegliwościami bólowymi.",
    image: girl1,
  },
  {
    id: 4,
    name: "",
    title: "Nauczycielka",
    text: "Pani Dominika dokładnie wszystko wyjaśniła, pokazała proste, aczkolwiek skuteczne ćwiczenia do samodzielnego wykonywania w domu dla kobiet w ciąży (po wykonaniu ich w gabinecie odczuwalna była już różnica). Osoba z dużą wiedzą i zaangażowaniem. Polecam:)",
    image: girl3,
  },
  {
    id: 5,
    name: "",
    title: "Inżynier",
    text: "Miła, kontaktowa a co najważniejsze profesjonalna.",
    image: boy2,
  },
  {
    id: 6,
    name: "",
    title: "Muzyk",
    text: "Każdą czynność poprzedza obszernym wyjaśnieniem. Obserwuje reakcje na ból i dostosowuje intensywność ćwiczeń.",
    image: boy3,
  },
  {
    id: 7,
    name: "",
    title: "Kierowca",
    text: "Dominika to czarodziejka. Polecam!",
    image: boy1,
  },
  {
    id: 8,
    name: "",
    title: "Pracownik biurowy",
    text: "Przychodzę do gabinetu z problemem i jak zawsze wychodzę już bez niego.",
    image: boy3,
  },
];
